import { useCallback, useEffect, useState } from 'react';
import { IconButton, Box, Link, Portal, Tooltip } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { useDefaultStyles } from '../../hooks/useDefaultStyles';
import { remoteConfig } from '../../client/firebase';

type Props = {
  iconColor?: string;
};

export function HelpButton({ iconColor = 'white' }: Props) {
  const [visible, setVisible] = useState(false);
  const [number, setNumber] = useState('');

  const { colors } = useDefaultStyles();

  const loadRemoteConfigData = useCallback(async () => {
    try {
      await fetchAndActivate(remoteConfig);
      const value = getValue(remoteConfig, 'contact_phone_number').asString() || '';
      setNumber(value);
    } catch (error) {
      console.error('Error fetching remote config:', error);
    }
  }, []);

  useEffect(() => {
    loadRemoteConfigData();
  }, [loadRemoteConfigData]);

  return (
    <>
      <Tooltip label="Ajuda" hasArrow>
        <Box
          as="button"
          onClick={() => setVisible(!visible)}
          fontSize="1.3rem"
          color={iconColor || colors.lighter.fromWhite}
        >
          <FontAwesomeIcon icon={faQuestionCircle} />
        </Box>
      </Tooltip>

      <Portal>
        {visible && (
          <Box
            position="fixed"
            bottom="24px"
            right="24px"
            zIndex={1000}
            transition="all 0.3s ease"
          >
            <Link
              href={`https://wa.me/${number}`}
              isExternal
              _hover={{ textDecoration: 'none' }}
            >
              <IconButton
                aria-label="WhatsApp"
                icon={<FontAwesomeIcon icon={faWhatsapp} />}
                colorScheme="whatsapp"
                borderRadius="full"
                size="lg"
                boxShadow="lg"
                _hover={{ transform: 'scale(1.06)' }}
                transition="all 0.15s"
                fontSize="2rem"
              />
            </Link>
          </Box>
        )}
      </Portal>
    </>
  );
}
